import React from 'react';
import PropTypes from 'prop-types';

import { bonusStatuses } from 'common/constants';
import BonusesTableRow from 'components/ClientProfile/Bonuses/DepositBonuses/BonusesTableRow';

const { ACTIVATED, CANCELED, COMPLETED, DISABLED, EXPIRED, IN_PROGRESS } = bonusStatuses;

const BonusTableListItemExpandTable = ({ bonus, wallet }) => {
  const { status } = bonus;

  const now = Date.now();

  if (status === IN_PROGRESS || status === ACTIVATED) {
    return <BonusesTableRow active bonus={bonus} now={now} wallet={wallet} />;
  }

  if (status === CANCELED || status === COMPLETED || status === DISABLED) {
    return <BonusesTableRow bonus={bonus} canceled now={now} wallet={wallet} />;
  }

  if (status === EXPIRED) {
    return <BonusesTableRow bonus={bonus} expired now={now} wallet={wallet} />;
  }

  return <BonusesTableRow bonus={bonus} now={now} wallet={wallet} />;
};

BonusTableListItemExpandTable.propTypes = {
  bonus: PropTypes.object.isRequired,
  wallet: PropTypes.object.isRequired,
};

export default BonusTableListItemExpandTable;
